import { render, staticRenderFns } from "./changetrends.vue?vue&type=template&id=65a8e4b7&scoped=true"
import script from "./changetrends.vue?vue&type=script&lang=js"
export * from "./changetrends.vue?vue&type=script&lang=js"
import style0 from "./changetrends.vue?vue&type=style&index=0&id=65a8e4b7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a8e4b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65a8e4b7')) {
      api.createRecord('65a8e4b7', component.options)
    } else {
      api.reload('65a8e4b7', component.options)
    }
    module.hot.accept("./changetrends.vue?vue&type=template&id=65a8e4b7&scoped=true", function () {
      api.rerender('65a8e4b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pricetrend/changetrends.vue"
export default component.exports